module.exports = __webpack_public_path__ + "img/fish.3c527966.png";